import {useHttp} from "./http.hook";
import {IDateExpRating, IRatingTicker, IRatingUser, TypesOfRating} from "../shared/types";
import {CountryExchange} from "../shared/countryExchange";

interface IDataSaveTickerRating {
  message: string,
}

interface IDataSaveDateExpRatingRating {
  message: string,
}

interface IDataGetAll {
  message: string,
  info: IRatingTicker[]
}


interface IDataGetAllDateExpRating {
  message: string,
  info: IDateExpRating[]
}

export const useTickerRating = () => {

  const {loading, request, error, clearError} = useHttp()

  //сохранение рейтинга компании
  const saveTickerRating = async (country: CountryExchange, ticker: string, fund: string) => {
    try {
      const data: IDataSaveTickerRating = await request('/api/ratings/save-one-rating', 'POST', {
        country: country,
        ticker: ticker,
        rating: fund,
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //сохранение рейтинга компании
  const saveAllTickerRatings = async (country: CountryExchange, ratingList: IRatingTicker[]) => {
    try {
      const data: IDataSaveTickerRating = await request('/api/ratings/save-all-ratings', 'POST', {
        country: country,
        ratingList: ratingList,
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //удаление рейтинга компании
  const removeTickerRating = async (country: CountryExchange, ticker: string) => {
    try {
      const data: IDataSaveTickerRating = await request('/api/ratings/remove-one-rating', 'POST', {
        country: country,
        ticker: ticker,
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //удаление всего списка рейтингов компаний
  const removeAllTickerRatings = async (country: CountryExchange) => {
    try {
      const data: IDataSaveTickerRating = await request('/api/ratings/remove-all-ratings', 'POST', {
        country: country
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //получение всех готовых рейтингов компаний из БД
  const getAllTickerRatings = async (country: CountryExchange) => {
    try {
      const data: IDataGetAll = await request('/api/ratings', 'POST', {
        country: country
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //получение всех рейтингов компаний с сайта investing.com
  const getAllTickerRatingsFromOutResource = async (country: CountryExchange, tickers: string[]) => {
    try {
      const data: IDataGetAll = await request('/api/ratings/get-from-out', 'POST', {
        country: country,
        tickers: tickers
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //сохранение даты экспирации для рейтинга
  const saveDateExpRating = async (country: CountryExchange, typeOfRating: TypesOfRating, dateExpiration: string) => {
    try {
      const data: IDataSaveDateExpRatingRating = await request('/api/ratings/save-date-expiration-rating', 'POST', {
        country: country,
        typeOfRating: typeOfRating,
        dateExpiration: dateExpiration
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //получение дат экспирации для всех типов рейтингов
  const getDateExpAllRatings = async (country: CountryExchange) => {
    try {
      const data: IDataGetAllDateExpRating = await request('/api/ratings/date-expiration-rating', 'POST', {
        country: country
      })
      return data
    } catch (e) {
      throw e
    }
  }

  return {
    loading,
    saveTickerRating,
    saveAllTickerRatings,
    getAllTickerRatings,
    removeTickerRating,
    removeAllTickerRatings,
    saveDateExpRating,
    getDateExpAllRatings,
    getAllTickerRatingsFromOutResource,
    error,
    clearError
  }
}